import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../auth';
import axios from '../../../api/axios';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';

function ModalTreshold({
    showModalTreshold,
    setShowModalTreshold,
    tokenUser
}) {

    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleClose = () => {
        setShowModalTreshold(false);
        setSelectedPilihan(null);
        setValuePilihan('');
    };

    const [listTreshold, setListTreshold] = useState([]);
    const [selectedPilihan, setSelectedPilihan] = useState(null);

    const selectOptions = listTreshold.map(treshold => ({
        value: treshold?.max_duration,
        label: treshold?.name,
        id: treshold?.id
    }));

    // console.log(selectedPilihan)

    const handleSelect = selectedOption => {
        setSelectedPilihan(selectedOption);
    };

    const retrieveTreshold = () => {
        axios.get(`/manage/food-treshold/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                // console.log(res.data)
                setListTreshold(res.data);
            }).catch(err => {
                console.error(err)
            })
    };

    useEffect(() => {
        if (tokenUser !== undefined) {
            retrieveTreshold();
        }
    }, [tokenUser]);

    const [valuePilihan, setValuePilihan] = useState(selectedPilihan?.value || '');

    useEffect(() => {

        setValuePilihan(selectedPilihan?.value || '');

    }, [selectedPilihan]);

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            fontFamily: 'Poppins-Regular'
        }),
        singleValue: (provided, state) => ({
            ...provided,
            textTransform: 'capitalize',
            color: theme === 'light' ? (state.isFocused ? 'red' : 'white') : (state.isFocused ? 'red' : '#222'),
        }),
        option: (provided, state) => ({
            ...provided,
            textTransform: 'capitalize',
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : '#fff',
            fontFamily: 'Poppins-Regular'
        }),
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        setIsSubmitting(true);
        setDisabled(true);

        const data = {
            max_duration: valuePilihan,
        };

        // console.log(data)

        try {
            const response = await axios.patch(`/manage/food-treshold/${selectedPilihan?.id}/`, data, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },
            }
            );

            handleClose();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengubah Nilai',
                showConfirmButton: true,
            });

            retrieveTreshold();

            setIsSubmitting(false);
            setDisabled(false);
        } catch (err) {
            console.error(err)
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengubah Nilai',
            });
            setIsSubmitting(false);
            setDisabled(false);
        }

    };


    return (
        <Modal
            show={showModalTreshold}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222', fontSize: '18px' }}>
                    Pengaturan Durasi untuk Konsumsi
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='pilihan'>Pilihan*</Form.Label>
                        <Select
                            id='pilihan'
                            options={selectOptions}
                            value={selectedPilihan}
                            onChange={handleSelect}
                            required
                            styles={selectStyles}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label style={formStyles.label} htmlFor='nilai'>Durasi (Menit)*</Form.Label>
                        <Form.Control
                            id='nilai'
                            type="number"
                            onChange={(e) => setValuePilihan(e.target.value)}
                            value={valuePilihan}
                            required
                            placeholder="Masukkan durasi"
                            style={formStyles.input}
                        />
                    </Form.Group>
                    <div className="d-grid gap-2 mt-4">
                        {isSubmitting ? (
                            <Button
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled
                            >
                                <Spinner
                                    animation="border"
                                    size='sm'
                                />
                            </Button>
                        ) : (
                            <Button
                                type="submit"
                                id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                variant='btn'
                                disabled={disabled}
                            >
                                Simpan
                            </Button>
                        )}
                    </div>
                </Form>
            </Modal.Body>

        </Modal>
    )
}

export default ModalTreshold
